<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.events')" :title="$t('help.actions_title')" />

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extend-button="false"
      :extended="true"
      global-filter="users.global"
      :loading="loading"
    />

    <div class="position-relative">
      <loader v-if="loading" />

      <v-server-table
        ref="automationsTable"
        name="automationsTable"
        url="/admin/events/handlers"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true"
        class="white-container"
      >
        <template slot="beforeFilter">
          <b-row>
            <b-col>
              <router-link to="actions/create">
                <b-button class="px-4">
                  {{ $t('actions.add') }}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </template>

        <template slot="id" slot-scope="props">
          <router-link
            :to="{ path: `/actions/edit/${props.row.id}`, params: props.row }"
            target="_blank"
          >
            {{ props.row.id }}
          </router-link>
        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{ $t('global.showing') }}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{ $t('global.of_records_found', { number: totalRecordsCount }) }}
        </template>

        <template slot="active" slot-scope="props">
          <column-check :row="props.row" column="active" />
        </template>

        <template slot="actions" slot-scope="props">
          <column-action
            :delete-url="`/events/handlers/${props.row.id}`"
            :route="{ path: `/actions/edit/${props.row.id}`, params: props.row }"
            @deleteItems="refreshTable('automationsTable')"
          />
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import axios from '@/utils/axios';
import i18n from '@/utils/i18n';
import { Event } from 'vue-tables-2';
import automationFilters from './automationFilters.js';
import filters from '@/components/global/filters';

export default {
  middleware: 'auth',
  name: 'Events',
  components: {
    filters,
  },
  data: () => {
    return {
      loading: false,
      totalRecordsCount: null,
      params: {
        page: 1,
        filter: {},
      },
      columns: ['id', 'type', 'event.title', 'template.name', 'condition', 'value_from_event', 'active', 'actions'],
      filters: automationFilters,
      options: {
        skin: [],
        headings: {
          id: '#',
          type: i18n.t('form.type'),
          'event.title': i18n.t('form.event'),
          'template.name': i18n.t('form.template'),
          condition: i18n.t('form.condition'),
          value_from_event: i18n.t('form.value_from_event'),
          active: i18n.t('form.active'),
          actions: i18n.t('button.edit'),
        },
        sortable: [],
        filterByColumn: false,
        columnsDropdown: false,
        customFilters: ['custom'],
        perPage:
          !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== ''
            ? localStorage.getItem('perPage')
            : 10,
        filterable: false,
        requestFunction: function (data) {
          localStorage.setItem('perPage', data.limit);
          return axios
            .get(this.url, {
              params: {
                limit: data.limit,
                filter: data.custom,
                page: data.page,
              },
            })
            .catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);
          return {
            data: data.data.items,
            count: data.data.paginator.total_items,
          };
        },
      },
    };
  },
  mounted() {
    Event.$on('vue-tables.automationsTable.loaded', ({ data }) => {
      this.totalRecordsCount = data.paginator.total_items;
    });
  },
  methods: {
    filter(params) {
      this.params = params;
      Event.$emit('vue-tables.automationsTable.filter::custom', params);
    },
  },
  destroyed() {
    Event.$off('vue-tables.automationsTable.loaded');
  },
};
</script>
